import { QueryCache, QueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { STATUS_CODES } from 'constant/http';
import { Logger } from 'utils/logger';

export const queryCache = new QueryCache({
  onError: (error) => {
    Logger.error({
      message: 'Query Cache Error: ',
      data: error,
    });
  },
});

/**
 * Create a new query client instance
 */
export const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      staleTime: 20 * 1000, // 20 seconds
      gcTime: 30 * 1000, // 30 seconds
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const status = (error as AxiosError)?.response?.status;
        // Avoid retrying for client errors (400-499)
        if (
          status &&
          status >= STATUS_CODES.BadRequest &&
          status < STATUS_CODES.InternalServerError
        )
          return false;
        return failureCount < 2;
      },
    },
    mutations: {
      onError(error) {
        Logger.error({ message: 'Mutation Error: ', data: error });
      },
    },
  },
});
